export default __webpack_public_path__ + "static/media/Tamarin Battle Bow.bd966709.jpg";